import { cartTotalStyles } from "@insite/content-library/Widgets/Cart/CartTotal";
import { css } from "styled-components";

cartTotalStyles.cancelPunchOutButton = {
    buttonType: "solid",
    variant: "secondary",
    css: css`
        width: 100%;
        margin-top: 10px;
        position: inherit;
        left: inherit;
        bottom: inherit;
    `,
};

cartTotalStyles.submitQuoteButton = {
    buttonType: "solid",
    variant: "secondary",
    css: css`
        width: 100%;
        margin-top: 10px;
        position: inherit;
        left: inherit;
        bottom: inherit;
    `,
};